<template>
<div>
  <v-container fluid grid-list-md>
    <app-account-choose></app-account-choose>
    <app-Account3-CRUD></app-Account3-CRUD>
  </v-container>
  </div>
</template>

<script>
import Account3CRUD from './Account3CRUD'
import AccountChoose from './AccountChoose'

export default {
  name: 'account3',
  data () {
    return {
      msg: ''
    }
  },
  mounted () {

  },
  methods: {

  },
  computed: {

  },
  watch: {

  },
  components: {
    appAccount3CRUD: Account3CRUD,
    appAccountChoose: AccountChoose
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
